function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import * as React from "react";

var Step2 = function Step2(props) {
  var claim = props.claim,
      onChangeClaim = props.onChangeClaim;
  return /*#__PURE__*/React.createElement("div", {
    className: "step"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-12"
  }, /*#__PURE__*/React.createElement("div", {
    className: "panel panel-default",
    style: {
      marginBottom: "1.5rem"
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "panel-heading"
  }, /*#__PURE__*/React.createElement("strong", null, "DATOS DEL DENUNCIANTE")), /*#__PURE__*/React.createElement("div", {
    className: "panel-body"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-4"
  }, /*#__PURE__*/React.createElement("label", {
    className: "form-label"
  }, "Denunciante"), /*#__PURE__*/React.createElement("input", {
    className: "form-control inputAddress",
    value: claim.name || "",
    onChange: function onChange(event) {
      onChangeClaim(_objectSpread(_objectSpread({}, claim), {}, {
        name: event.target.value
      }));
    },
    placeholder: "Nombre del denunciante"
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-md-4"
  }, /*#__PURE__*/React.createElement("label", {
    className: "form-label"
  }, "Correo electr\xF3nico"), /*#__PURE__*/React.createElement("input", {
    type: "email",
    className: "form-control inputAddress",
    value: claim.email || "",
    onChange: function onChange(event) {
      onChangeClaim(_objectSpread(_objectSpread({}, claim), {}, {
        email: event.target.value
      }));
    },
    placeholder: "Email del denunciante"
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-md-4"
  }, /*#__PURE__*/React.createElement("label", {
    className: "form-label"
  }, "Tel\xE9fono"), /*#__PURE__*/React.createElement("input", {
    type: "tel",
    className: "form-control inputAddress",
    value: claim.phone || "",
    onChange: function onChange(event) {
      onChangeClaim(_objectSpread(_objectSpread({}, claim), {}, {
        phone: event.target.value
      }));
    },
    placeholder: "Tel\xE9fono del denunciante"
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-md-4"
  }, /*#__PURE__*/React.createElement("label", {
    className: "form-label"
  }, "RUT denunciante"), /*#__PURE__*/React.createElement("input", {
    className: "form-control inputAddress",
    value: claim.claimant_rut || "",
    onChange: function onChange(event) {
      onChangeClaim(_objectSpread(_objectSpread({}, claim), {}, {
        claimant_rut: event.target.value
      }));
    },
    placeholder: "RUT del denunciante"
  }))))))));
};

export default Step2;